<template>
  <v-app id="inspire">
    <div class="d-flex align-center">
      <div class="cover"> 
        <div class="logoforcover"></div>
      </div>
    </div>

    <v-main>
        <v-card rounded="0" style="padding:5px"  color="#0D1231" height="100%" width="100%" elevation="0">
          
          <v-row justify="center" align="center" no-gutters style="height:100%;">
              <v-card height="400" width="400" elevation="0" color="#0D1231">
                     <v-text-field  v-model="email" dark outlined label="כתובת דוא״ל" type="email"  color="white"></v-text-field>
                      <v-text-field v-if="mask" v-model="password"  dark outlined label="סיסמה" type="password" color="white"  append-icon="mdi-eye" @click:append="mask = !mask"></v-text-field>
                      <v-text-field v-if="!mask" v-model="password"  dark outlined label="סיסמה"  color="white"  append-icon="mdi-eye-off" @click:append="mask = !mask"></v-text-field>

                      <v-btn text  dark color="#0288D1" style="margin-bottom:10px;color:white" elevation="0" @click="sendRestMail" >שכחתי סיסמה</v-btn>
                      <v-btn @click="login" block dark color="#0288D1">
                        <div>התחברות</div>
                      </v-btn>
                      <v-alert v-model="alert" style="margin-top:10px" text outlined :color="alertColor" >                       
                       {{msg}}
                      </v-alert>
              </v-card>
          </v-row>
        </v-card>
    </v-main>
  </v-app>
</template>

<script>
import { auth } from '../firebase'

  export default {
    data: () => ({ 
       email:'',
       password:'',
       msg:'',
       alert:false,
       alertColor:'',
       loading:false,
       mask:true,
       alertIcon:''
    }),


    methods:{
      login(){
          auth.signInWithEmailAndPassword(this.email,this.password).then(res=>{
            console.log(res)
          }).catch(error=>{
            console.log(error)
            this.msg = ''
            this.showError(error.code)
          })
      },

      showError(errorCode){
        let errorMessage = '';
        switch (errorCode){
          case 'auth/user-not-found':
              errorMessage = 'לא נמצא משתמש על כתובת דוא״ל זו'
            break;

          case 'auth/invalid-credential':
              errorMessage = 'פרטי התחברות אינם תקינים'
            break;

          case 'auth/wrong-password':
              errorMessage = 'סיסמה לא נכונה'

            break;

          case 'auth/user-disabled':
              errorMessage = 'משתמש זה אינו פעיל יותר אנא פנא אלינו טלפונית '
            break;
                                            
          case 'auth/user-disabled':
              errorMessage = 'משתמש זה אינו פעיל יותר אנא פנא אלינו טלפונית'
            break;

            case 'auth/too-many-requests':
              errorMessage = 'גישה לחשבון זה נחסמה זמנית עקב ריבוי ניסיונות התחברות שנכשלו. באפשרותך לאפס סיסמה על ידי לחיצה על ״שכחתי סיסמה״ ולהחתבר שוב או לנסות שוב מאוחר יותר'
            break;                          
          default:
              errorMessage = 'שגיאת התחברות'  
            break;  
        }
        this.showMsg('error',errorMessage)
      },

      showMsg(type,msg){
         this.msg = ''
         this.msg = msg;
         if(type == 'error'){
           this.alertIcon = 'mdi-alert'
           this.alertColor='deep-orange'
         }
        if(type == 'info'){
           this.alertIcon = 'mdi-info'
           this.alertColor='blue lighten-4'

         }
         this.alert = true;
      },
      sendRestMail(){
        auth.sendPasswordResetEmail(this.email).then(res=>{
          let data = this;
          this.showMsg('info',
          `שלחנו הודעה עם הנחיות לאיפוס הסיסמה לכתובת ${data.email}`
          );
        }).catch(error=>{
            let errorMessage = ''
            switch(error.code){
               case 'auth/invalid-email':
                  errorMessage = 'כתובת המייל אינה תקינה'
                 break;
               
               case 'auth/user-not-found':
                  errorMessage = 'לא קיים אצלנו משתמש עם כתובת המייל הזו'
                 break;

              default:
                  errorMessage = 'לא הצלחנו לשלוח לך מייל איפוס אנא צור איתנו קשר'
                break;
             }
            this.msg = ''
            this.showMsg('error',errorMessage);
        })
      }
    },
  }
</script>

<style>
  .cover{
    background-image: url('../assets/Bitmap.png');
    width:100vw;height:250px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position-x: 50%;
    background-position-y: 65%;
    position: relative;
  }
  .logoforcover{
      background-image: url('../assets/logo4.png');
      width:200px;height:100px;
      background-size: 200px 100px;
      background-position-x: 50%;
      background-position-y: 50%;
      background-repeat: no-repeat;
      position: absolute;
      left: calc(50% - 100px);
      top:calc(30%);
  }
</style>